import { Flex } from '@components/Flex';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import styled from 'styled-components';
import { ReactComponent as ApplePay } from './apple-pay.svg';
import { ReactComponent as Gpay } from './gpay.svg';
import { ReactComponent as Card } from './card.svg';
import { Box } from '@components/Box';

export const StyledCardWrapper = styled(Box)`
  .text-pairing-title {
    max-width: 75%;
  }
  ${themeMediaQuery('md')} {
    .text-pairing-title {
      max-width: 346px;
    }
  }
`;

export const StyledIconWrapper = styled(Flex)`
  flex-direction: row;
  gap: ${themeSpace(2)};
`;

export const StyledApplePay = styled(ApplePay)`
  ${themeMediaQuery('below_sm')} {
    height: 40px;
    width: auto;
  }
`;

export const StyledGPay = styled(Gpay)`
  ${themeMediaQuery('below_sm')} {
    height: 40px;
    width: auto;
  }
`;

export const StyledCreditCard = styled(Card)`
  ${themeMediaQuery('below_sm')} {
    height: 40px;
    width: auto;
  }
`;
